// Pure rules for showing recipe (Breakdown) UI in the Cost Library.

/** Recipe UI is UK only. A missing market defaults to UK; any other or unknown value does not qualify. */
export function isUkRecipeMarket(market: string | null | undefined): boolean {
  if (market === null || market === undefined) return true;
  return market === "uk";
}

interface RecipeFlags { hasRecipe?: boolean; hasRecipeOverride?: boolean; hasDefaultRecipe?: boolean; source?: string }

/** Recipe-owned Typical changes need explicit breakdown reconciliation; legacy rate writers cannot bypass it. */
export function isRecipeBacked(task: RecipeFlags, admin = false): boolean {
  if (admin && task.source !== "custom" && task.hasDefaultRecipe !== undefined) return task.hasDefaultRecipe;
  return task.hasRecipe === true || task.hasRecipeOverride === true;
}

/** The generic, unconfirmed override delete must not remove a recipe override; the panel Reset (confirmed) is used instead. */
export function allowsGenericOverrideReset(task: RecipeFlags & { source: string; overrideId?: string | null }): boolean {
  return task.source === "override" && !!task.overrideId && task.hasRecipeOverride !== true;
}
